<app-whole-health-balance-checkbox [whbCheckboxTooltip]="entry.base.tooltip" [whbCheckboxLabel]="entry.base.text"
    variation="radio">
</app-whole-health-balance-checkbox>